import script from "./IPDPharmacyInvoiceEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./IPDPharmacyInvoiceEdit.vue?vue&type=script&setup=true&lang=js"

import "./IPDPharmacyInvoiceEdit.vue?vue&type=style&index=0&id=0c88c63c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c88c63c"]])

export default __exports__